module.exports = __webpack_public_path__ + "static/media/logo.fe226500.svg";